import { render, staticRenderFns } from "./SkyboxList.vue?vue&type=template&id=89ca128a&scoped=true&"
import script from "./SkyboxList.vue?vue&type=script&lang=js&"
export * from "./SkyboxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ca128a",
  null
  
)

export default component.exports